const loginHelpActivationCodeEntryTemplate = `<pwr-mfa></pwr-mfa>`;
export default loginHelpActivationCodeEntryTemplate;
